import type { TemplateOnlyComponent } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { BlogPost } from 'teacher-ui-client/components/contentful/blog-post'
import type { BlogEntry } from 'teacher-ui-client/subscription-type/blog/post/route.ts'

interface BlogTemplateArgs {
  model: BlogEntry
}

const BlogTemplate: TemplateOnlyComponent<BlogTemplateArgs> = <template>
  <div class="m-0 w-full grow">
    <BlogPost @model={{@model}} />
  </div>
</template>

export default RouteTemplate(BlogTemplate)
